// InterestPillGrid — icon pills for the simple free-text profile interests
// (personalData.interests). Controlled by props; toggling one plays a select
// micro-motion (pillPop, gated behind prefers-reduced-motion). Selected pills
// fill with --gradient-primary and show a --color-success-tinted confirmed tick.
// Operates ONLY on the simple INTERESTS list — never the rich wizard interest
// categories or memory tags (three distinct systems; do not cross them).

import { interestIcon } from '../../data/interestIcons';
import './InterestPillGrid.css';

interface InterestPillGridProps {
  interests: string[];
  selected: string[];
  onToggle: (interest: string) => void;
}

export function InterestPillGrid({ interests, selected, onToggle }: InterestPillGridProps) {
  return (
    <div className="interest-pill-grid" role="group" aria-label="Interests">
      {interests.map((interest) => {
        const isSelected = selected.includes(interest);
        return (
          <button
            key={interest}
            type="button"
            className={`interest-pill ${isSelected ? 'selected' : ''}`}
            aria-pressed={isSelected}
            onClick={() => onToggle(interest)}
          >
            <span className="interest-pill__icon" aria-hidden="true">
              {interestIcon(interest)}
            </span>
            <span className="interest-pill__label">{interest}</span>
            {isSelected && (
              <span className="interest-pill__check" aria-hidden="true">
                ✓
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default InterestPillGrid;
